export const authMixin = {
    data() {
        return {
            isLoggedIn: false,
            accessToken: false
        }
    },
    methods: {
        getSubString(str, start, end){
            return str.substring(str.indexOf(start) + 1, str.indexOf(end));
        }
    }
    
}